import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypesByEventId, getCountries } from "ticketino-api-client";
import axios from "axios";


import Header from './components/Header'
import Footer from "./components/Footer";
import Loading from "./components/Loading";

const Step10_Shipping = () => {
    const [orderId, setOrderId] = useState();

    const [ticketTypeIdSommerfest1, setTicketTypeIdSommerfest1] = useState(0);
    const [ticketTypeIdSommerfest2, setTicketTypeIdSommerfest2] = useState(0);

    const [eventId1, setEventId1] = useState(0);
    const [eventId2, setEventId2] = useState(0);
    const [posId, setPosId] = useState(0);
    const [organizerId, setOrganizerId] = useState(0);

    const [orderLoaded, setOrderLoaded] = useState(false);
    const [tokenLoaded, setTokenLoaded] = useState(false);

    const [errors, setErrors] = useState("");

    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        function: "",
        email: "",
        street: "",
        city: "",
        postCode: "",
        code1: "", //house number
        code2: "", //fachbereit
        countryId: 176, // Default to Switzerland
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [countries, setCountries] = useState([]);

    // fetching params - get ticket type ID from URL
    const { language, ticketTypeId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        // Redirect back to home if no ticket type ID is selected
        if (!ticketTypeId) {
            navigate(`/${language}/home`);
            return;
        }

        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));

    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // Note: We no longer need to start order here since it's handled in requestFormSettings
    }, [language, tokenLoaded]); //everytime language is changed

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            setTokenLoaded(true);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID etc
            setOrganizerId(res.data.organizerId);
            setPosId(res.data.posId);
            setEventId1(res.data.eventId1);
            setEventId2(res.data.eventId2);
            setTicketTypeIdSommerfest1(res.data.sommerfest1TicketTypeId);
            setTicketTypeIdSommerfest2(res.data.sommerfest2TicketTypeId);

            // Check if we already have an order stored from the Home page
            const existingOrderId = sessionStorage.getItem("orderId");
            
            if (existingOrderId && existingOrderId !== "0") {
                // Reuse existing order
                setOrderId(existingOrderId);
                setOrderLoaded(true);
            } else {
                // Create new order only if none exists
                const selectedEventId = parseInt(ticketTypeId) === res.data.sommerfest1TicketTypeId
                    ? res.data.eventId1
                    : res.data.eventId2;
                startOrder(res.data.posId, selectedEventId);
            }
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 10,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setOrderLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const addTicketToBasket = async () => {

        let addTicketTypes = [];

        // Use hardcoded countryId 176 (Switzerland)
        let country = countries.find(c => c.id === 176);

        addTicketTypes.push({
            ticketTypeId: parseInt(ticketTypeId), // Use ticket type ID from URL
            quantity: 1,
            salutation: buyerInfo.salutation,
            firstname: buyerInfo.firstName,
            lastname: buyerInfo.name,
            Function: buyerInfo.function,
            email: buyerInfo.email,
            street: buyerInfo.street,
            postCode: buyerInfo.postCode,
            city: buyerInfo.city,
            country: country?.name || "Schweiz",
            option10: buyerInfo.code1, //house number
            option11: buyerInfo.code2, //fachbereich
        });

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                addAddressToBasket();
            })
            .catch((error) => {
                console.error(error.response.data);

                sessionStorage.removeItem("orderId");
                setOrderId(null);
                setOrderLoaded(false);

                //if order is missing start a new one
                // Determine which event ID to use based on the selected ticket type
                const selectedEventId = parseInt(ticketTypeId) === ticketTypeIdSommerfest1
                    ? eventId1
                    : eventId2;
                startOrder(posId, selectedEventId);
            });
    };

    const addAddressToBasket = async () => {
        let addressBody = { ...buyerInfo };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {
                // gtm - addAddress
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addAddress'
                });
                finishFreeOrder();
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const finishFreeOrder = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
        } catch (error) {
            console.error(error)
        }
    };

    const onSubmit = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        if (validateEntries()) {
            setIsSubmitting(true);

            try {
                // Fetch orders from both events
                const { event1Orders, event2Orders } = await fetchOrdersByEventIds();

                // Check if user already has orders for either event
                const hasEvent1Orders = event1Orders && event1Orders.length > 0;
                const hasEvent2Orders = event2Orders && event2Orders.length > 0;

                if (hasEvent1Orders || hasEvent2Orders) {
                    // User is already registered for at least one event
                    setErrors(resources?.AlreadyRegistered);
                    setIsSubmitting(false);
                    return;
                }

                // Store ticket type ID for confirmation page
                sessionStorage.setItem("SelectedTicketTypeId", ticketTypeId);

                await addTicketToBasket();
            } catch (error) {
                console.error("Error during submission:", error);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            }
        }
    };

    const onInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBuyerInfo((prevBuyerInfo) => ({
            ...prevBuyerInfo,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateEntries = () => {

        if (!(buyerInfo.salutation && buyerInfo.salutation.trim() !== "") ||
            !(buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName)) ||
            !(buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name)) ||
            !(buyerInfo.code1 && /^.{1,70}$/.test(buyerInfo.code1)) ||
            !(buyerInfo.code2 && /^.{1,70}$/.test(buyerInfo.code2)) ||
            !(buyerInfo.function && /^.{1,70}$/.test(buyerInfo.function)) ||
            !(buyerInfo.street && /^.{1,70}$/.test(buyerInfo.street)) ||
            !(buyerInfo.postCode && /^.{1,70}$/.test(buyerInfo.postCode)) ||
            !(buyerInfo.city && /^.{1,70}$/.test(buyerInfo.city))) {
            setErrors(resources?.FillMandatoryFields);
            return false;
        }
        else if (!(buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email))) {
            setErrors(resources?.EmailNotCorrect);
            return false;
        }
        setErrors("");
        return true;
    }

    const fetchOrdersByEventIds = async () => {
        const token = sessionStorage.getItem("token");

        if (!token) {
            console.error("No token available for fetching orders");
            return { event1Orders: [], event2Orders: [] };
        }

        try {
            // Use buyer's email as filter text
            const emailFilter = buyerInfo.email;

            // Fetch orders for both events
            const [ordersEvent1Response, ordersEvent2Response] = await Promise.all([
                axios.get(
                    `${baseUrl}/Orders?eventId=${eventId1}&includeCancelledOrders=false&filterText=${encodeURIComponent(emailFilter)}&numberToSkip=0`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ),
                axios.get(
                    `${baseUrl}/Orders?eventId=${eventId2}&includeCancelledOrders=false&filterText=${encodeURIComponent(emailFilter)}&numberToSkip=0`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
            ]);

            return {
                event1Orders: ordersEvent1Response.data?.orderList || [],
                event2Orders: ordersEvent2Response.data?.orderList || []
            };
        } catch (error) {
            console.error("Error fetching orders:", error);
            return { event1Orders: [], event2Orders: [] };
        }
    };

    return (
        <div>
            <Header resources={resources} />
            {loading ? (
                <>
                    <Loading
                        alignment="center"
                        color="#d3d3d3"
                        bgColor="#fff"
                        top="50%"
                    />

                </>
            ) : (
                <>
                    <div className="container page-container">
                        <div className="mt-4 page-container-smaller">

                            {/* participant */}
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2">
                                    {resources?.BuyerSalutation}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-sm-9 col-md-8 col-12">
                                    <div className="d-flex gap-4">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="salutation"
                                                id="salutationHerr"
                                                value={resources?.Mr}
                                                checked={buyerInfo.salutation === resources?.Mr}
                                                onChange={onInputChange}
                                            />
                                            <label className="form-check-label" htmlFor="salutationHerr">
                                                {resources?.Mr}
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="salutation"
                                                id="salutationFrau"
                                                value={resources?.Ms}
                                                checked={buyerInfo.salutation === resources?.Ms}
                                                onChange={onInputChange}
                                            />
                                            <label className="form-check-label" htmlFor="salutationFrau">
                                                {resources?.Ms}
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="salutation"
                                                id="salutationDivers"
                                                value={resources?.Diverse}
                                                checked={buyerInfo.salutation === resources?.Diverse}
                                                onChange={onInputChange}
                                            />
                                            <label className="form-check-label" htmlFor="salutationDivers">
                                                {resources?.Diverse}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="name">
                                    {resources?.BuyerLastname}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-sm-12 col-md-8 col-12">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        value={buyerInfo.name}
                                        id="name"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="firstName">
                                    {resources?.BuyerFirstname}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-sm-12 col-md-8 col-12">
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="form-control"
                                        value={buyerInfo.firstName}
                                        id="firstName"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="street">
                                    {resources?.BuyerStreet} / {resources?.BuyerHouseNumber} {resources?.BuyerWorkplace}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-md-8 col-12 row pe-0">
                                    <div className="col-md-8 col-8 pe-0">
                                        <input
                                            type="text"
                                            name="street"
                                            className="form-control"
                                            value={buyerInfo.street}
                                            id="street"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="col-md-4 col-4 pe-0">
                                        <input
                                            type="text"
                                            name="code1"
                                            className="form-control"
                                            value={buyerInfo.code1}
                                            id="code1"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="postCode">
                                    {resources?.BuyerPostcode} / {resources?.BuyerCity} {resources?.BuyerWorkplace}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-md-8 col-12 row pe-0">
                                    <div className="col-md-4 col-4 pe-0">
                                        <input
                                            type="text"
                                            name="postCode"
                                            className="form-control"
                                            value={buyerInfo.postCode}
                                            id="postCode"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="col-md-8 col-8 pe-0">
                                        <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            value={buyerInfo.city}
                                            id="city"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="email">
                                    {resources?.BuyerEmail}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-md-8 col-sm-12 col-12">
                                    <input
                                        type="text"
                                        name="email"
                                        className="form-control"
                                        value={buyerInfo.email}
                                        id="email"
                                        disabled={false}
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="function">
                                    {resources?.BuyerFunction}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-sm-12 col-md-8 col-12">
                                    <input
                                        type="text"
                                        name="function"
                                        className="form-control"
                                        value={buyerInfo.function}
                                        id="function"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-md-4 col-12 mb-2" htmlFor="code2">
                                    {resources?.BuyerFachbereit}: <span className="mandatory">*</span>
                                </label>
                                <div className="col-md-8 col-sm-12 col-12">
                                    <input
                                        type="text"
                                        name="code2"
                                        className="form-control"
                                        value={buyerInfo.code2}
                                        id="code2"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-12 text-end">
                                    <button
                                        className="btn-register button"
                                        onClick={() => onSubmit()
                                        }
                                    >
                                        {resources?._Register}
                                    </button>
                                </div>
                            </div>

                            {errors !== "" && (
                                <div className="row text-start mt-4">
                                    <div className="offset-md-6 col-md-6"></div>
                                    <p className="text-danger ps-2">*{errors}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <Footer language={language} />
                </>
            )}
        </div>
    )
}

export default Step10_Shipping
